import { render, staticRenderFns } from "./TermsNotification.vue?vue&type=template&id=df1e19be"
import script from "./TermsNotification.vue?vue&type=script&lang=js"
export * from "./TermsNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports